export const REFRESH_PANEL = 'REFRESH_PANEL';
